import React, { Fragment } from 'react';
import { AtriumLine } from '../ui';
export function TrustStrip() {
  const trustSignals = ['50+ Years', 'Three Generations', 'Family-Owned', 'HIA & MBA Recognised', '4.7 Google Rating (21 reviews)', 'Applecross Display Home', 'Ardross WA'];
  return <section className="bg-atrium-green relative z-20" data-id="element-342">
      <AtriumLine color="bronze" className="absolute top-0 left-0 w-full" data-id="element-343" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8" data-id="element-344">
        <div className="flex flex-wrap justify-center md:justify-between items-center gap-x-8 gap-y-4" data-id="element-345">
          {trustSignals.map((signal, index) => <Fragment key={index} data-id="element-346">
              <span className="text-xs md:text-sm font-medium tracking-wide text-atrium-ivory whitespace-nowrap" data-id="element-347">
                {signal}
              </span>
              {index < trustSignals.length - 1 && <span className="hidden md:block w-1 h-1 rounded-full bg-atrium-bronze/40" aria-hidden="true" data-id="element-348" />}
            </Fragment>)}
        </div>
      </div>
    </section>;
}